import { useCallback } from "react";
import { useNavigation } from "@react-navigation/native";

/**
 * Let the closing screen start its dismiss animation before the next navigation is dispatched.
 * Dispatching both in the same frame makes iOS drop the incoming screen while the modal it should
 * replace is still being torn down.
 */
const CLOSE_ANIMATION_DELAY = 100;

/**
 * Closes the current screen, then runs `navigate`.
 *
 * On native a screen declared with `presentation: "modal"` inside a NESTED navigator (e.g. the
 * Invitation screen of the todo list stack) is a real system modal covering its parent navigator:
 * a screen pushed on that parent while the modal is still presented ends up BEHIND it, so the app
 * looks stuck on the modal (BAS-2880). Closing first guarantees the target screen is on top,
 * whichever navigator owns it.
 */
export const useCloseScreenThenNavigate = () => {
    const navigation = useNavigation();

    return useCallback(
        (navigate: () => void) => {
            if (navigation.canGoBack()) {
                navigation.goBack();
            }
            setTimeout(navigate, CLOSE_ANIMATION_DELAY);
        },
        [navigation],
    );
};
